// extracted by mini-css-extract-plugin
export default {"blank__container":"BlankBlockContainer_blank__container__cSaaS"};